<div class="d-flex flex-row upload-container" [ngClass]="{'upload-error': fileUploadStatus.isError}">
  <div class="d-flex align-items-center justify-content-center">

      <span class="upload-icon-background"
            *ngIf="fileUploadStatus.progress === 100">
        <img class="upload-icon" [src]="fileUploadStatus.fileIcon" alt="">
      </span>
      <mat-spinner diameter="25" *ngIf="fileUploadStatus.progress < 100 && !fileUploadStatus.isError" class="get-upload-file-spinner"></mat-spinner>

  </div>

  <div class="upload-file-text">
    <span *ngIf="fileUploadStatus.isError" style="color: #ac2355; font-weight: bold; font-size: 0.95rem;">{{'file.fileUploadError'|translate}}</span> <br>
    <span> {{fileUploadStatus.fileName}}</span> <br>
    <span *ngIf="fileUploadStatus.isError" (click)="retryFileUpload()"
          style="color: #ac2355; font-weight: bold; font-size: 0.95rem; cursor: pointer; text-decoration: underline; margin-top: 5px; display: inline-block;">
      {{'file.fileUploadTryAgain'|translate}}
    </span> <br>
    <div class="d-flex justify-content-start upload-file-subtext" *ngIf="fileUploadStatus.isError === false">
      {{fileUploadStatus.fileSize | formatFileSize}}
      <div class="d-flex justify-content-start align-items-center ms-1 me-3"
           *ngIf="fileUploadStatus.progress === 100">{{'file.uploadComplete'|translate}}
        <mat-icon>done</mat-icon>
      </div>
    </div>
    <span> </span>
    <div *ngIf="fileUploadStatus.progress < 100 && !fileUploadStatus.isError" class="w-100 d-flex">
      <mat-progress-bar class="upload-progress-bar" mode="determinate"
                        [value]="fileUploadStatus.progress">
      </mat-progress-bar>
      <span class="upload-percentage-number">
                  {{fileUploadStatus.progress}}%
                </span>
    </div>
  </div>
  <button class="upload-delete-button"  *ngIf="!fileUploadStatus.isError" (click)="deleteFileUpload(fileUploadStatus.id)"><img
    src="../../../assets/img/form/trashbin.svg" alt="">
  </button>
  <button class="upload-delete-button"  *ngIf="fileUploadStatus.isError" (click)="clearFileUpload(fileUploadStatus.internalId)"><img
    src="../../../assets/img/form/trashbin-error.svg" alt="">
  </button>
</div>
